import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch, store } from "../../../../redux/store";
import { fetchClaims } from "../actions";
import MainTable from "../../../../components/mainTable";
import { ModalType } from "../../../../shared/utils/enums";
import { Claim } from "../../../../interfaces/screens/billing";
import {
  showModal,
  hideModal,
} from "../../../../connected-components/modal/reducer";
import ClaimEditor from "../../../../components/claimEditor";
import { getClaimsTableColumns } from "../../../../shared/tableColumns/claimsColumns";

const ClaimsDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    data: claims,
    loading,
    error,
  } = useSelector((state: RootState) => state.billing.claims);

  useEffect(() => {
    dispatch(fetchClaims());
  }, [dispatch]);

  const handleEditClaim = (claim: Claim) => {
    dispatch(
      showModal({
        title: `Edit Claim ${claim.id}`,
        type: ModalType.COMPONENT,
        component: (
          <ClaimEditor
            key={claim.id}
            claim={claim}
            onClose={() => store.dispatch(hideModal())}
          />
        ),
      }),
    );
  };

  const columns = getClaimsTableColumns({ onEdit: handleEditClaim });

  return (
    <div>
      <MainTable columns={columns} data={claims} isLoading={loading} />
      {error && (
        <p className="text-red-500 mt-4">Error fetching claims: {error}</p>
      )}
    </div>
  );
};

export default ClaimsDashboard;
